import clsx from 'clsx'
import type { ReactNode } from 'react'
import { View, type ViewProps } from 'react-native'

type TPlaceholderProps = {
  noBackground?: boolean
  contrast?: 'dark' | 'light'
} & ViewProps

export const Placeholder = ({
  children,
  className,
  noBackground,
  contrast = 'light',
  ...props
}: TPlaceholderProps): ReactNode => {
  return (
    <View
      className={clsx(
        'animate-pulse flex-row rounded-2xl p-4',
        {
          'bg-transparent': noBackground,
          'bg-default-bg-loading': !noBackground && contrast === 'light',
          'bg-default-bg-loading-dark': !noBackground && contrast === 'dark',
        },
        className,
      )}
      {...props}
    >
      {children}
    </View>
  )
}
